// import loadableWithRetry from '../common/loadableWithRetry'

// const AddToHistory = loadableWithRetry(() => import('./AddToHistory'))'

import AddToHistory from './AddToHistory'

export default AddToHistory;
